import { useQuery } from 'react-query'
import { getCustomerData } from '../cm-api/get-customer-data'

export function useCustomerData(customerId) {
  return useQuery(
    ['getCustomerPlan', customerId],
    () => getCustomerData(customerId),
    {
      enabled:
        Boolean(customerId) && Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
    },
  )
}
